import { CSSProperties } from "@mui/styles/withStyles";
import { Add } from "@material-ui/icons";
import { Typography, Button } from "@mui/material";
import { ColorUtils } from "../../utils/ColorUtils";

const styles: ('absolute' | 'relative' | 'fixed') = 'absolute';
const gridStyles: ('absolute' | 'relative' | 'fixed') = 'relative';

export const customButtonsContainer = {
  padding: 0,
  position: styles,
  top: "-50px",
  right: 0,
  backgroundColor: "transparent",
  boxShadow: "none",
}

export const gridButtonContainer: CSSProperties = {
  position: gridStyles
} 

// Custom button builder function
export const customButtonBuilder = (onClick: () => void, style?: CSSProperties) => (
  // @ts-ignore
  <Button
  type="submit"
  startIcon={<Add />}
  color="primary"
  sx={{
    color: "#ffffff", 
    backgroundColor: ColorUtils.ENSOLVERS_ORANGE_REBRANDING,      
    '&:hover': {
      backgroundColor: "#484747",
    },
  }}
  onClick={onClick}
  >
    <Typography variant="body1">Add</Typography>
  </Button>
);
